import React, { useEffect, useContext } from 'react';
import { CanvasContext } from 'components/upload-image/CanvasContext';
import { NO_TOOL_SELECTED } from 'constants/tools';
// import BlackWhiteFilter from './filters/BlackWhiteFilter';
import VintageFilter from './filters/VintageFilter';
import WarmGlowFilter from './filters/WarmGlowFilter';
import CoolToneFilter from './filters/CoolToneFilter';
// import FadedFilmFilter from './filters/FadedFilmFilter';
// import SepiaFilter from './filters/SepiaFilter';
// import SoftPastelFilter from './filters/SoftPastelFilter';
import VibrantPopFilter from './filters/VibrantPopFilter';
import CinematicFilter from './filters/CinematicFilter';
import NaturalEnhanceFilter from './filters/NaturalEnhanceFilter';
import BrightFilter from './filters/BrightFilter';
import ClearFilter from './filters/ClearFilter';

export default function FiltersTool({ isActive }) {
  const { pendingExitTool, setPendingExitTool, setActiveTool } =
    useContext(CanvasContext);

  useEffect(() => {
    if (pendingExitTool === 'filters') {
      setPendingExitTool(null); // reset it
      setActiveTool(NO_TOOL_SELECTED); // now safely exit
    }
  }, [pendingExitTool, setPendingExitTool, setActiveTool]);

  if (!isActive) return null;

  return (
    <div className="w-full px-4 py-3">
      {/* Horizontal scroller to prevent vertical “bob” while swiping on mobile */}
      <div
        className={[
          'w-full',
          'overflow-x-auto overflow-y-hidden',
          'touch-pan-x', // key: only allow horizontal pan inside this region
          'overscroll-y-none', // reduces vertical bounce feel on iOS
          'pb-3 md:pb-0', // tiny breathing room so borders/rings don’t get clipped
          'snap-x snap-mandatory',
          'scroll-px-4',
        ].join(' ')}
      >
        <div className="flex md:flex-wrap gap-6 w-max md:mx-auto">
          <NaturalEnhanceFilter />

          <BrightFilter />

          <ClearFilter />

          <WarmGlowFilter />

          {/* <BlackWhiteFilter /> */}

          <VintageFilter />

          <CoolToneFilter />

          {/* <FadedFilmFilter />

          <SepiaFilter />

          <SoftPastelFilter /> */}

          <VibrantPopFilter />

          <CinematicFilter />
        </div>
      </div>
    </div>
  );
}
